import React, { useEffect, useState, useContext } from 'react';
import TopicCard from '../../components/topicCard/TopicCard';
import DropdownMenu from '../../components/dropdownMenu/DropdownMenu';
import './Recent.css';
import Floatbar from '../../components/floatbar/Floatbar';
import AuthContext from '../../contexts/AuthContext';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { FaRegClock } from 'react-icons/fa';
import IconHeading from '../../components/sectionHeading/IconHeading';

export function Recent() {
    const { user } = useContext(AuthContext);
    const [topicData, setTopicData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = useState("latest"); // Default to latest sorting
    const [page, setPage] = useState(1); // For pagination

    const sortOptions = [
        { value: 'latest', label: 'Latest to Earliest' },
        { value: 'earliest', label: 'Earliest to Latest' },
    ];

    // Fetch topics when sorting or page changes
    const getRecentTopics = async (sortOrder = "latest") => {
        setLoading(true);

        const interval = 25;
        const start = (page - 1) * interval;
        const end = start + interval;

        // Step 1: Sort topicHistory based on visitedAt
        const sortedHistory = user.topicHistory.sort(
            (a, b) => new Date(b.visitedAt) - new Date(a.visitedAt)
        );

        // Step 2: Paginate sorted history
        //const paginatedTopics = sortedHistory.slice(start, end);
        const topicIds = sortedHistory.map((history) => history.topicId);

        // Step 3: Fetch topic details for the paginated topic IDs
        const response = await fetch('/api/topic/getTopics', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ topicIds })
        });

        if (response.ok) {
            const res = await response.json();

            // Step 4: Assign topic statuses
            const updatedTopicData = assignTopicStatus(res.data);

            // Step 5: Sort updatedTopicData based on sortOrder using visitedAt from topicHistory
            let sortedTopicData = updatedTopicData.sort((a, b) => {
                const historyA = user.topicHistory.find(
                    (history) => history.topicId === a.topicId
                );
                const historyB = user.topicHistory.find(
                    (history) => history.topicId === b.topicId
                );

                return new Date(historyB.visitedAt) - new Date(historyA.visitedAt);
                // Sort based on sortOrder
            });

            if (sortOrder === "earliest") {
                sortedTopicData.reverse();
            }
            setTopicData(() => [...sortedTopicData]); // Replace with sorted data
        }
        setLoading(false);
    };

    const assignTopicStatus = (topicDatas) => {
        return topicDatas.map((topicData) => {
            let status = 0;
            if (user.topicStatus.learned.includes(parseInt(topicData.topicId))) {
                status = 2;
            } else if (user.topicStatus.maybe.includes(parseInt(topicData.topicId))) {
                status = 1;
            } else if (user.topicStatus.verified.includes(parseInt(topicData.topicId))) {
                status = 3;
            }

            return { ...topicData, topicStatus: status };
        });
    };

    const handleSortChange = (value) => {
        setSortOrder(value); // Update the sort order
        setPage(1);          // Reset to page 1 when sorting changes
        setLoading(true);
        setTopicData([]);    // Clear previous data
        getRecentTopics(value);
    };

    const loadMore = () => {
        if (!loading) {
            setPage(prevPage => prevPage + 1); // Increment page to load more data
        }
    };

    // Infinite scroll logic on window scroll
    const handleScroll = () => {
        if (
            window.innerHeight + window.scrollY >= document.body.offsetHeight - 10 &&
            !loading
        ) {
            loadMore();
        }
    };

    useEffect(() => {
        //// Attach scroll event listener to window
        //window.addEventListener("scroll", handleScroll);
        //return () => {
        //    // Cleanup the event listener
        //    window.removeEventListener("scroll", handleScroll);
        //};
    }, [loading]);

    useEffect(() => {
        getRecentTopics();
    }, [page]);

    return (
        <>
            <div id="content-container">
                <IconHeading icon={FaRegClock} title="Most Recent Topic" headingSize="medium" />
                <hr />

                <div className="inline-block-wrapper margin-top-30">
                    {/* Sorting Dropdown */}
                    <div>
                        <DropdownMenu
                            label=""
                            options={sortOptions}
                            selectedValue={sortOrder}
                            onOptionSelect={handleSortChange}
                        />

                        <div className="topic-card-deck card-columns margin-btm-30 margin-top-15">
                            {topicData.length > 0
                                ? topicData.map((topic, index) => (
                                    <Link to={`/topic/${topic.topicId}`} key={index}>
                                        <TopicCard
                                            topicName={topic.name}
                                            views={topic.views}
                                            estimatedTime={topic.estimatedTime}
                                            tags={topic.tagNames}
                                            topicStatus={topic.topicStatus}
                                        />
                                    </Link>
                                ))
                                : loading
                                    ? <Skeleton count={3} width={200} />
                                    : <h3 className="empty-state">No Recent Topic...Yet</h3>
                            }
                        </div>
                    </div>
                <Floatbar />
                </div>
            </div>
        </>
    );
}
